module.exports = __webpack_public_path__ + "static/media/Purchase2.73e95c5d.png";